import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceLocationStoreActions, DeviceLocationStoreStates } from './index';

@Injectable()
export class DeviceLocationResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly deviceLocationStore: Store<DeviceLocationStoreStates.DeviceLocationState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.deviceLocationStore.dispatch(
          DeviceLocationStoreActions.DeviceLocationResolverActions.deviceLocationRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
